import React from "react";
import emptyStateSvg from "shared/assets/illustrations/emptyState.svg";
import "./noDataFoundStyles.css";

interface INoDataFoundProps{
    title:string,
    subTitle:string
}
const NoDataFound: React.FC<INoDataFoundProps> = (props): JSX.Element => {
    const {title, subTitle} = props;
    return (
        <div id="noDataComponent" className="illustrationContainer">
            <img alt="illustration" src={emptyStateSvg} width="332px" height="251px" />
            <div className="illustrationTitle">
                {title}
            </div>
            <div className="illustrationSubTitle">
                {subTitle}
            </div>
        </div>
    )
}

export default NoDataFound;